var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("emd-container", {
        attrs: { title: _vm.$t("identification") },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "eu-flex" }, [
                  _c(
                    "div",
                    { staticClass: "eu-flex-item eu-basis_12 eu-basis_12_md" },
                    [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c("label", { staticClass: "emd-label" }, [
                          _vm._v(_vm._s(_vm.$t("linkName")) + " "),
                          _c("span", { staticClass: "label-optional" }, [
                            _vm._v("(" + _vm._s(_vm.$t("optional")) + ")"),
                          ]),
                        ]),
                        _c("input", {
                          staticClass: "emd-input",
                          class: {
                            _state_error:
                              _vm.$v.paymentLinkData.name.$invalid &&
                              _vm.showFeedbacks.status,
                          },
                          attrs: { placeholder: _vm.$t("linkNamePlaceholder") },
                          domProps: { value: _vm.paymentLinkData.name },
                          on: {
                            input: function ($event) {
                              return _vm.changeValue($event, "name")
                            },
                          },
                        }),
                        !_vm.$v.paymentLinkData.name.maxLength &&
                        _vm.showFeedbacks.status
                          ? _c(
                              "p",
                              {
                                staticClass: "emd-input-feedback _state_error",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("hint.length", { length: "64" })
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c("label", { staticClass: "emd-label" }, [
                          _vm._v(_vm._s(_vm.$t("orderCode")) + " "),
                          _c("span", { staticClass: "label-optional" }, [
                            _vm._v("(" + _vm._s(_vm.$t("optional")) + ")"),
                          ]),
                        ]),
                        _c("input", {
                          staticClass: "emd-input",
                          class: {
                            _state_error:
                              _vm.$v.orderCode.$invalid &&
                              _vm.showFeedbacks.status,
                          },
                          attrs: {
                            placeholder: _vm.$t("orderCodePlaceholder"),
                          },
                          domProps: { value: _vm.orderCode },
                          on: {
                            input: function ($event) {
                              return _vm.setOrderCodeValue($event)
                            },
                          },
                        }),
                        !_vm.$v.orderCode.maxLength && _vm.showFeedbacks.status
                          ? _c(
                              "p",
                              {
                                staticClass: "emd-input-feedback _state_error",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("hint.length", { length: "64" })
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }